<template>
  <div>
    <BaseProgressBarHeader
      v-if="withHeader"
      :current="current"
      :total="total"
      :goal="goal"
      :over-subscription="overSubscription"
    />
    <div class="progress-bar rounded-full">
      <div
        :style="{
          width: `${intRatio}%`,
        }"
        class="h-full bg-orange rounded-full"
      />
    </div>
    <BaseGreyText class="font-sans-medium">
      {{ $t('Updated today at') }} {{ new Date() | moment('HH:mm') }}
    </BaseGreyText>
  </div>
</template>

<script>
import BaseOrangeText from './BaseOrangeText.vue';
import BaseGreyText from './BaseGreyText.vue';
import BaseProgressBarHeader from './BaseProgressBarHeader.vue';

export default {
  name: 'BaseProgressBar',
  components: {
    BaseOrangeText,
    BaseGreyText,
    BaseProgressBarHeader,
  },
  props: {
    current: {
      type: Number,
      required: true,
    },
    withHeader: {
      type: Boolean,
      default: true,
    },
    goal: {
      type: Number,
      required: true,
    },
    overSubscription: {
      type: Number,
      required: true,
    },
  },
  computed: {
    total() {
      return (this.goal + ((this.overSubscription * this.goal) / 100));
    },
    intRatio() {
      const ratio = parseInt((this.current / this.total) * 100, 10);
      if (ratio > 100) {
        return 100;
      }
      return ratio;
    },
  },
};
</script>

<style lang="css" scoped>
.progress-bar {
  margin-top: 7px;
  margin-bottom: 10px;
  background-color: rgba(122, 131, 142, 0.3);
  height: 6px;
}
</style>
